import styled from "styled-components";

export const Filtro = styled.div`
    width: 100%;
    div{
        width: 100%;
        margin: 5px;
        display: flex;
        justify-content: end;
    }
    .setor-status{
        width: 150px;
        height: 24px;
        margin-right: 10px;
    }
    .empresa{
        width: 90%;
        height: 24px;
        margin-right: 5px;
    }
    select{
        width: 100px;
        height: 24px;
        margin-right: 5px;
    }
    label{
        margin-right: 5px;
    }
    .search{
        width: 90%;
    }
`